import React, { useEffect, useState } from "react";
import Header from "components/Header";
import DashboardMap from "components/MaharashtraMap";
import DataCard1 from "components/NewComponents/DataCard1";
import DataCard2 from "components/NewComponents/DataCard2";
import SectionDivider from "components/NewComponents/SectionDivider1";
import MaharashtraMapView from "components/NewComponents/Map1";
import AreaChartCard from "components/NewComponents/AreaChartCard";
import LineBarChart from "components/NewComponents/LineBarChartCard";
import DonutChart from "components/NewComponents/DonutChartCard";
import BarChart from "components/NewComponents/BarChart"
import {
    FaUsers,        // Population
    FaMapMarkedAlt, // District
    FaCity,         // Tehsil
    FaMapSigns,     // Block
    FaHome,         // Gram Panchayat
    FaTree,         // Village
    FaLocation,       // location
    FaBaby,
    FaHospital,
    FaSyringe,
    FaHeartbeat,
    FaUserMd
} from "react-icons/fa";

const healthCareData = [
    {
        icon: <FaUsers />,
        title: "Population",
        value: "112,374,333",
        sub: "(Census 2011)",
        color: "#1976D2",
    },
    {
        icon: <FaMapMarkedAlt />,
        title: "District",
        value: "36",
        color: "#1976D2",
    },
    {
        icon: <FaCity />,
        title: "Taluka",
        value: "358",
        color: "#1976D2",
    },
    {
        icon: <FaMapSigns />,
        title: "Block",
        value: "352",
        color: "#1976D2",
    },
    {
        icon: <FaHome />,
        title: "Gram Panchayat",
        value: "28,349",
        color: "#1976D2",
    },
    {
        icon: <FaTree />,
        title: "Village",
        value: "44,753",
        color: "#1976D2",
    },
];


const indicatorData = [
    {
        title: "4 or more ANC",
        value: "95%",
        icon: <FaHeartbeat />,
        bgColor: "bg-pink-100",
        iconColor: "text-pink-500",
        comparison: "↑ 3% from last quarter",      // trend info
        benchmark: "State Avg: 92%"               // context
    },
    {
        title: "Institutional Delivery",
        value: "91%",
        icon: <FaHospital />,
        bgColor: "bg-blue-100",
        iconColor: "text-blue-500",
        comparison: "↓ 1% from last year",
        benchmark: "State Avg: 88%"
    },
    {
        title: "Fully Immunized",
        value: "95%",
        icon: <FaBaby />,
        bgColor: "bg-green-100",
        iconColor: "text-green-500",
        comparison: "↑ 2% from last quarter",
        benchmark: "State Avg: 90%"
    },
    {
        title: "MMR",
        value: "33 / 10,00,000",
        icon: <FaUserMd />,
        bgColor: "bg-orange-100",
        iconColor: "text-orange-500",
        comparison: "↓ 5 from last year",
        benchmark: "National Target: <50"
    },
    {
        title: "NMR",
        value: "11 / 1000",
        icon: <FaUserMd />,
        bgColor: "bg-sky-100",
        iconColor: "text-sky-500",
        comparison: "↓ 1 from last year",
        benchmark: "National Avg: 9/1000"
    },
    {
        title: "IMR",
        value: "16 / 1000",
        icon: <FaHeartbeat />,
        bgColor: "bg-violet-100",
        iconColor: "text-violet-500",
        comparison: "↓ 2 from last year",
        benchmark: "National Avg: 14/1000"
    },
];


const immunizationData = {
    Pune: 72,
    Nagpur: 64,
    Nashik: 59,
    Mumbai: 88,
    Aurangabad: 77,
};
const AreaChartsData = [
    { district: "Pune", institutional: 1200, csection: 450 },
    { district: "Nashik", institutional: 900, csection: 300 },
    { district: "Nagpur", institutional: 1100, csection: 400 },
    { district: "Thane", institutional: 1000, csection: 350 },
    { district: "Aurangabad", institutional: 950, csection: 320 },
];
const MaleFemaleLBWData = [
    { district: "Pune", male: 9200,lbw: 6.5 },
    { district: "Nashik", male: 8100, lbw: 7.2 },
    { district: "Nagpur", male: 10000, lbw: 9.1 },
    { district: "Mumbai", male: 13800, lbw: 6.3 },
    { district: "Amravati", male: 13800, lbw: 6.4 },
];
const fullyImmunizedData = [
    { name: "Male", value: 1800 },
    { name: "Female", value: 2100 }
];
export const districtHealthCareData = [
    { icon: <FaUsers />, title: "Population", value: "11,23,74,333", sub: "(Census 2011)", color: "#1976D2" },
    { icon: <FaMapMarkedAlt />, title: "District", value: "36", color: "#1976D2" },
    { icon: <FaCity />, title: "Taluka", value: "358", color: "#1976D2" },
    { icon: <FaMapSigns />, title: "Block", value: "352", color: "#1976D2" },
    { icon: <FaHome />, title: "Gram Panchayat", value: "28,349", color: "#1976D2" },
    { icon: <FaTree />, title: "Village", value: "44,753", color: "#1976D2" },
];
const flabels = ["PHC", "CHC", "Sub Center", "DH", "SDH"];

const datasets = [
    {
        label: "Rural (R)",
        data: [120, 90, 150, 60, 40],
        backgroundColor: "#4F46E5",
        borderRadius: 6,
        barThickness: 18,
    },
    {
        label: "Urban (U)",
        data: [80, 110, 50, 100, 70],
        backgroundColor: "#F43F5E",
        borderRadius: 6,
        barThickness: 18,
    },
];

function MaternalHealthDashboard() {
    const [districtView, setDistrictView] = useState(null);
    const [seed, setSeed] = useState(0);
    // const [currentBirths, setCurrentBirths] = useState(DEFAULT_BIRTHS);
    const [stateGeoJSON, setStateGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // state polygon
            .then((res) => res.json())
            .then((data) => setStateGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);

    const [districtsGeoJSON, setdistrictsGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // <- all districts
            .then((res) => res.json())
            .then((data) => setdistrictsGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);
    const handleMenuClick = () => {
        // alert("Sidebar opened! (You can link this to real sidebar)");
    };

    const [searchQuery, setSearchQuery] = useState("");
    const [selected, setSelected] = useState("");
    return (
        <>
            <Header
                onMenuClick={handleMenuClick}
                selected={selected}
                setSelected={setSelected}
                onSearchChange={setSearchQuery}
                dashboardName="Maternal Health Dashboard"
            />

            <div className="container-fluid p-2">
                {/* Health Data Card */}
                <div className="grid grid-cols-1 md:grid-cols-1 gap-2">
                    <DataCard1 healthCareData={districtHealthCareData} />
                </div>

                {/* Maternal & Child Health Indicators */}
                <div className="grid grid-cols-1 gap-2 mt-2">
                    <DataCard2 indicators={indicatorData} />
                </div>

                {/* Charts & Map Section */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 mt-3">

                    {/* Map */}
                    <div className="lg:col-span-5 w-full">
                        <MaharashtraMapView
                            title="Total number of new pregnant women registered for ANC"
                            dataMap={immunizationData}
                            colorRange={["#dbeafe", "#1e3a8a"]}
                            onDistrictSelect={(district) => console.log("Clicked:", district)}
                            height="620px" // let container control height
                        />
                    </div>

                    {/* Area & Line/Bar Charts */}
                    <div className="lg:col-span-4 w-full flex flex-col gap-4">
                        <AreaChartCard
                            title="Institutional Deliveries vs C-Section Deliveries (Top 5 District)"
                            dataPoints={AreaChartsData}
                            height="250px"
                        />
                        <LineBarChart
                            title="Live Births vs Low Birth Weight"
                            dataPoints={MaleFemaleLBWData}
                            height="250px"
                        />
                    </div>

                    {/* Donut & Bar Charts */}
                    <div className="lg:col-span-3 w-full flex flex-col gap-4">
                        <DonutChart
                            data={fullyImmunizedData}
                            title="Fully Immunized - Male vs Female"
                            height={250}
                        />
                        <BarChart
                            title="Facility Ratio (Rural vs Urban)"
                            labels={flabels}
                            datasets={datasets}
                            height={250}
                        />
                    </div>
                </div>
            </div>
        </>

    )
}
export default MaternalHealthDashboard;